export default function useTheme(serviceStyle) {
	if (!serviceStyle) {
		return;
	}

	const {
		bg,
		primary,
		mainBtn,
		baseBtn,
		infoColor,
		snsIcon,
		caption,
		text,
		wizdomeLogoColor,
		bookBtn,
		etcBtn,
		mybookBtn,
		cancelBtn,
		faqBtn,
	} = serviceStyle;

	const style = document.documentElement.style;

	style.setProperty('--bg-image', `url(${bg.imagePath})`);
	style.setProperty(
		'--bg-image-mobile',
		`url(${bg.imageMobilePath || bg.imagePath})`,
	);
	style.setProperty('--bg-position', bg.position || 'fixed');
	style.setProperty(
		'--bg-background-position',
		bg.backgroundPosition || 'center',
	);

	style.setProperty('--primary', primary);
	style.setProperty('--primary-10', primary + '1A');

	style.setProperty('--ticket-color', primary);
	style.setProperty('--ticket-color-10', primary + '1A');

	style.setProperty('--btn-color', mainBtn?.color || '#000');
	style.setProperty('--btn-color-hover', mainBtn?.colorHover || '#000');
	style.setProperty('--btn-bg', mainBtn?.bg || '#fff');
	style.setProperty('--btn-bg-hover', mainBtn?.bgHover || '#fff');
	style.setProperty('--btn-border', mainBtn?.border || '#fff');

	style.setProperty('--btn-active-bg', baseBtn?.active || primary);

	style.setProperty('--info-color', infoColor || '#fff');

	style.setProperty('--sns-bg', snsIcon?.bg || '#fff');
	style.setProperty('--sns-bg-hover', snsIcon?.bgHover || primary);
	style.setProperty('--sns-color', snsIcon?.color || '#000');
	style.setProperty('--sns-color-hover', snsIcon?.colorHover || '#fff');

	style.setProperty('--caption-child', caption?.child);
	style.setProperty('--caption-old', caption?.old);

	style.setProperty('--main-info-color', text?.mainInfo || '#fff');
	style.setProperty('--side-menu-info-color', text?.sideMenuInfo || '#fff');

	style.setProperty('--wizdome-logo-color', wizdomeLogoColor || '#fff');

	bookBtn?.bg ? style.setProperty('--book-btn-bg', bookBtn.bg) : null;
	bookBtn?.color ? style.setProperty('--book-btn-color', bookBtn.color) : null;
	bookBtn?.border
		? style.setProperty('--book-btn-border', bookBtn.border)
		: null;
	etcBtn?.bg ? style.setProperty('--etc-btn-bg', etcBtn.bg) : null;
	etcBtn?.color ? style.setProperty('--etc-btn-color', etcBtn.color) : null;
	etcBtn?.border ? style.setProperty('--etc-btn-border', etcBtn?.border) : null;
	mybookBtn?.bg ? style.setProperty('--mybook-btn-bg', mybookBtn?.bg) : null;
	mybookBtn?.color
		? style.setProperty('--mybook-btn-color', mybookBtn?.color)
		: null;
	mybookBtn?.border
		? style.setProperty('--mybook-btn-border', mybookBtn?.border)
		: null;
	cancelBtn?.bg ? style.setProperty('--cancel-btn-bg', cancelBtn?.bg) : null;
	cancelBtn?.color
		? style.setProperty('--cancel-btn-color', cancelBtn?.color)
		: null;
	cancelBtn?.border
		? style.setProperty('--cancel-btn-border', cancelBtn?.border)
		: null;
	faqBtn?.bg ? style.setProperty('--faq-btn-bg', faqBtn?.bg) : null;
	faqBtn?.color ? style.setProperty('--faq-btn-color', faqBtn?.color) : null;
	faqBtn?.border ? style.setProperty('--faq-btn-border', faqBtn?.border) : null;
}
